import Animate from './Animate';
import AnimateChild from './AnimateChild';
import CSSMotion from './CSSMotion';

export { AnimateChild, CSSMotion };

export default Animate;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/~/rc-trigger/~/rc-animate/es/index.js
// module id = 1625
// module chunks = 14